import React from 'react';
import { X } from 'lucide-react';
import { Section } from './Shared';
export const PainPoints = () => {
  const points = ['Llegás a la sesión sin saber exactamente qué serie prescribir para el cuadro que tenés enfrente', 'Improvisás movimientos porque no tenés un protocolo clínico que te respalde', 'No sabés cómo estructurar la sesión completa — apertura, trabajo y cierre', 'Absorbés la energía densa de tus pacientes porque no tenés un protocolo de blindaje real', 'Sin protocolo de higiene energética del espacio entre sesiones', 'Sin series adaptadas por patología — armás cada sesión desde cero', 'Sin ficha clínica profesional — cada consulta sin registro ni continuidad', 'Sin planificación anual — trabajás semana a semana sin visión estratégica', 'Pacientes que no vuelven porque no perciben resultados concretos', 'Cada sesión la empezás de cero — sin estructura real ni respaldo clínico'];
  return <Section className="max-w-4xl" data-id="element-240" data-mp="3ncxqxypinvm1">
      <div className="text-center mb-12" data-id="element-241" data-mp="3nbwfvu8i394b">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-semibold mb-6 leading-tight text-brand-burgundy" data-id="element-242" data-mp="1z058r50vwuzm">
          ¿Cuántas sesiones más vas a improvisar sin un sistema clínico sólido?
        </h2>
        <p className="text-brand-text mb-4 text-sm md:text-base max-w-2xl mx-auto" data-id="element-243" data-mp="27t8jv6o24vr3">
          Sos terapeuta de Chi Kung. Amás lo que hacés. Creés en el poder
          transformador del Qi y el movimiento consciente. Pero hay una verdad
          que nadie te dijo cuando empezaste:
        </p>
        <p className="text-brand-goldDark mb-4 text-base md:text-lg max-w-2xl mx-auto font-semibold" data-id="element-244" data-mp="1b3hpd7frn8la">
          Saber Chi Kung no es lo mismo que tener un sistema clínico para
          aplicarlo con autoridad profesional.
        </p>
        <p className="text-lg md:text-xl font-medium text-brand-burgundy mt-6 font-serif italic" data-id="element-245" data-mp="1k1uth69gva8r">
          Y esa diferencia la sentís cada vez que entrás al consultorio.
        </p>
      </div>

      <div className="glass-panel p-6 md:p-10 rounded-3xl mb-12 border-brand-goldDark/20" data-id="element-246" data-mp="2vi1hd7kbvbnt">
        <h3 className="font-serif font-semibold mb-6 flex items-center text-brand-burgundy text-lg md:text-xl" data-id="element-247" data-mp="1t4dhh4ipvc9d">
          <X className="w-6 h-6 text-brand-burgundy mr-2 shrink-0" data-id="element-248" data-mp="1y2exfgkuivgm" /> Lo que
          pasa SIN el Mega Pack Chi Kung:
        </h3>
        <ul className="space-y-4" data-id="element-249" data-mp="274xwrqpfapy4">
          {points.map((point, i) => <li key={i} className="flex items-start" data-id="element-250" data-mp="274eh6gn8wdn9" data-mpi={i}>
              <X className="w-5 h-5 text-brand-burgundy/80 mr-3 mt-0.5 shrink-0" data-id="element-251" data-mp="1af73fusvb8tw" />
              <span className="text-brand-text text-sm md:text-base" data-id="element-252" data-mp="1eg8vnrodakmd">
                {point}
              </span>
            </li>)}
        </ul>
      </div>

      <div className="text-center" data-id="element-253" data-mp="1jdsjnjavabri">
        <h3 className="text-2xl md:text-3xl font-serif italic font-medium text-brand-burgundy" data-id="element-254" data-mp="1o624ikx4klmx">
          ¿Y si esta fuera la última sesión que trabajás así?
        </h3>
      </div>
    </Section>;
};